import { Button } from '@mui/material'
import React from 'react'

export default function RecommendationHeader({
  recommendationType,
  recommendationOrderNumber,
  recommendationTitle,
  handleRemoveRecommendation,
}) {
  return (
    <div className='d-flex justify-content-between align-items-center mb-2'>
      <strong style={{ color: '#4c1d95' }}>{recommendationTitle}</strong>
      <Button
        color="inherit"
        variant="outlined"
        size="small"
        sx={{ textTransform: 'none', border: '1px solid #ebebeb', borderRadius: '8px' }}
        onClick={() => {
          handleRemoveRecommendation(recommendationType, recommendationOrderNumber)
        }}
      >
        Remove
      </Button>
    </div>
  )
}
